import { HTMLHint } from 'htmlhint';

export const htmlLinter = (view) => {
  const doc = view.state.doc;
  const content = doc.toString();

  const results = HTMLHint.verify(content, {
    'tagname-lowercase': true,
    'attr-lowercase': true,
    'attr-value-double-quotes': true,
    'doctype-first': false,
    'tag-pair': true,
    'spec-char-escape': false,
    'id-unique': true,
    'src-not-empty': true,
    'attr-no-duplication': true
  });

  const diagnostics = results.map((result) => {
    const fromPos = doc.line(result.line).from + result.col - 1;
    const toPos = doc.line(result.line).from + result.col;

    return {
      from: fromPos,
      to: toPos,
      line: result.line,
      message: result.message,
      severity: result.type === 'error' ? 'error' : 'warning'
    };
  });

  const event = new CustomEvent('htmlLintErrors', { detail: diagnostics });
  window.dispatchEvent(event);

  return diagnostics;
};
